$(function() {

	var faqs = {

		vars: {
			slider: null,
			settings: {
				infinite: false,
				arrows: false,
				dots: false,
				centerMode: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				mobileFirst: true,
				responsive: [{
						breakpoint: 600,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 799,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 1104,
						settings: 'unslick'
					},
				]
			}
		},

		el: {
			list: $('.list-links'),
			win: $(window),
			main: $('.faqs')
		},

		init: function() {
			faqs.vars.slider = faqs.el.list;
			faqs.vars.slider.slick(faqs.vars.settings);

			faqs.el.win.on('resize', function() {
				if ($(window).width() > 1104) {
					if (faqs.vars.slider.hasClass('slick-initialized')) {
						faqs.vars.slider.slick('unslick');
					}
					return
				}

				if (!faqs.vars.slider.hasClass('slick-initialized')) {
					return faqs.vars.slider.slick(faqs.vars.settings);
				}
			});


			faqs.el.main.on('click', '.faqs-panels__trigger', function() {
				var active = faqs.el.main.find('.faqs-panels__item--open');
				active
					.removeClass('faqs-panels__item--open')
					.find('.faqs-panels__content').addClass('faqs-panels__content--hidden');

				var el = $(this).closest('.faqs-panels__item');

				if (active.index() != el.index()) { //only open if it is a new item
					el.addClass('faqs-panels__item--open').find('.faqs-panels__content').removeClass('faqs-panels__content--hidden');
				}

			}).on('click', '.list-links__link', function(e) {
				e.preventDefault();
				$('.list-links__link--active').removeClass('list-links__link--active');
				var el = $(this);
				var index = el.parent().index();
				el.addClass('list-links__link--active');

				$('.faqs-panels--active')
					.removeClass('faqs-panels--active')
					.addClass('faqs-panels--hidden')
					.find('.faqs-panels__item--open')
					.removeClass('faqs-panels__item--open')
					.find('.faqs-panels__content')
					.addClass('faqs-panels__content--hidden');

				var panel = faqs.el.main.find('.faqs-panels').eq(index);
				var panelImage = faqs.el.main.find('.faqs__images').eq(index);

				panel.find('.faqs-panels__item').each(function(index, el) {
					var item = $(el);
					TweenMax.to(item, 0, {
						alpha: 0,
						x: 50
					});
					TweenMax.to(item, .5, {
						alpha: 1,
						x: 1,
						delay: .1 * index
					});
				});
				panelImage.find('img').each(function(index, el) {
					var item = $(el);
					TweenMax.to(item, 0, {
						alpha: 0,
						x: 50
					});
					TweenMax.to(item, .5, {
						alpha: 1,
						x: 1,
						delay: .1 * index
					});
				});

				panel.removeClass('faqs-panels--hidden').addClass('faqs-panels--active');
				panelImage.removeClass('faqs-panels--hidden').addClass('faqs-panels--active');
			});
		}

	}

	faqs.init();

});